<div class="flex-column flex-fill">

  <div>
    <div style="position: absolute; right: 10px; z-index: 1;">
      @if (selectedTabIndex === 0) {
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.folderOpen" class="me-1"
        (click)="openScenario()" [disabled]="selectedScenarioId == null">
        Open
      </button>
      }

      @if (selectedTabIndex > 1) {
      <kendo-splitbutton #exportButton [buttonLoading]="loading" [svgIcon]="icons.excel"
        [data]="exportButtonData" (buttonClick)="exportButtonLogic(); exportButton.togglePopupVisibility()" (open)="exportButtonLogic()">
        Export Detail
      </kendo-splitbutton>
      }

      @if (selectedTabIndex !== 0) {
      <button type="button" kendoButton themeColor="primary" [disabled]="loading || isReadOnly"
        [buttonLoading]="loading" [svgIcon]="icons.save" class="me-1" (click)="updateCapital()">
        Update Capital
      </button>
      }
    </div>
  </div>

  <kendo-tabstrip [keepTabContent]="true" class="no-padding-tab flex-fill" #forecastTabStrip>
    <kendo-tabstrip-tab [title]="'Scenarios'" [selected]="true">
      <ng-template kendoTabContent>
        <app-forecast-scenarios class="flex-column flex-fill flex-100"></app-forecast-scenarios>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'Uplifts'">
      <ng-template kendoTabContent>
        <app-uplifts class="flex-column flex-fill flex-100"></app-uplifts>
      </ng-template>
    </kendo-tabstrip-tab>
    @for (tabItem of tabItems; track tabItem; let i=$index) {
    <kendo-tabstrip-tab [selected]="false">
      <ng-template kendoTabTitle>
        <div class="project-tab" #tabstripTabItem>
          Scenario {{ tabItem }}
          <div class="project-tab--close" (click)="closeTab(i)">
            <i class="material-icons">clear</i>
          </div>
        </div>
      </ng-template>
      <ng-template kendoTabContent>
        <app-forecast-scenario-detail class="flex-column flex-fill flex-100" [ScenarioId]="tabMeta.get(tabItem)?.scenarioId ?? null" [ParentBuildId]="tabMeta.get(tabItem)?.parentBuildId ?? null">
        </app-forecast-scenario-detail>
      </ng-template>
    </kendo-tabstrip-tab>
    }
  </kendo-tabstrip>
</div>

@if (isShowingDownloadDialog) {
<kendo-dialog title="Download {{detailTypeDescription}} Forecast Details (Scenario {{selectedScenarioId}}-{{selectedCapitalForecastLogId}})" (close)="isShowingDownloadDialog = false"
  [minWidth]="250">
  <div class="k-form">
    <div class="row">
      <label for="example-search-input" class="col-4 col-form-label">Start Date</label>
      <div class="col-8">
        <kendo-datepicker #startDateModel="ngModel" [(ngModel)]="startDate" required></kendo-datepicker>
      </div>
    </div>
    <div class="row">
      <label for="example-search-input" class="col-4 col-form-label">End Date</label>
      <div class="col-8">
        <kendo-datepicker #endDateModel="ngModel" [(ngModel)]="endDate" required></kendo-datepicker>
      </div>
    </div>
    <div class="form-group row">
      <div class="offset-sm-4 col-sm-8 pt-3">
        <button type="button" class="k-button" (click)="isShowingDownloadDialog = false">Cancel</button>
        <button type="button" class="k-button k-primary"
          [disabled]="startDateModel.invalid || endDateModel.invalid"
          (click)="downloadDetailedForecastSheet()">Download</button>
      </div>
    </div>
  </div>
</kendo-dialog>
}

@if (showUpdateCapitalForecastDialog) {
<kendo-dialog title="Please Confirm" (close)="onClickCloseCapital()">
  <div style="display: flex; flex-direction: column; gap: 10px; padding: 10px;">
    <div style="display: flex; align-items: center;">
      <label style="width: 150px; font-weight: bold;">Effective Date:</label>
      <kendo-datepicker
        #effectiveDateModel="ngModel"
        [(ngModel)]="effectiveDate"
        required
        style="flex: 1;"></kendo-datepicker>
    </div>
    <div style="display: flex; align-items: start;">
      <label for="userComment" style="width: 150px; font-weight: bold;">Comments:</label>
      <textarea
        id="userComment"
        [(ngModel)]="userComment"
        rows="4"
        maxlength="500"
        placeholder="Enter your comments here."
        style="flex: 1; resize: none; padding: 5px; border: 1px solid #ccc; border-radius: 4px;">
        </textarea>
    </div>
  </div>
  <p style="margin: 10px; text-align: center;">
    This is a long-running process. Are you sure you want to update capital for Scenario
    <strong>{{ this.selectedScenarioId }}</strong>?
  </p>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="onClickCloseCapital()">No</button>
    <button type="button" kendoButton
      [disabled]="effectiveDateModel.invalid"
      (click)="updateCapitalConfirm(this.selectedScenarioId);"
      themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}